(function ($) {
  Drupal.behaviors.aerinCarouselV1 = {
    attach: function (context, settings) {
      self = this;

      // $(window).resize(function(){
      if ($(window).width() < 736) {
        // mobileCarousel = true;
        args = self.mobileSettings;
      } else {
        args = self.pcSettings;
      }
      // })

      var $carousel = $('.aerin-carousel-formatter-v1', context);

      // Carousel formatter
      $('.slick-carousel', $carousel).each(function () {
        args['autoplay'] = $(this).data('auto');
        $(this).slick(args);
      });
    }, // attach
    mobileCarousel: null,
    pcSettings: {
      arrows: true,
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '15%'
    },
    mobileSettings: {
      arrows: true,
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1
    },
    carouselArgs: null
  };
})(jQuery);
